import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight, Database, Layout, Zap, Shirt, Shield, BugOff, Gamepad, Gamepad2, Drill } from 'lucide-react';
const ventures = [{
  name: 'QA Mage',
  category: 'Developer Tools',
  description: 'A modern platform for automated application testing.',
  icon: BugOff,
  color: 'bg-[#E8F0FE]',
  iconColor: 'text-blue-600'
}, {
  name: 'WearBooth',
  category: 'Fashion',
  description: 'Turn any garment photo into a scroll-stopping model shoot.',
  icon: Shirt,
  color: 'bg-[#FCE8E6]',
  iconColor: 'text-red-600'
}, {
  name: 'FunPond',
  category: 'Gaming',
  description: 'Mobile gaming platform.',
  icon: Gamepad2,
  color: 'bg-[#FEF7E0]',
  iconColor: 'text-yellow-600'
}, {
  name: 'ServiceOps',
  category: 'SMEs',
  description: 'The command center for trades businesses.',
  icon: Drill,
  color: 'bg-[#E6F4EA]',
  iconColor: 'text-green-600'
}];
export function Ventures() {
  return <section id="ventures" className="py-32 px-6 md:px-12 bg-cream" data-id="element-158">
      <div className="max-w-7xl mx-auto" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-8" data-id="element-160">
          <div data-id="element-161">
            <h2 className="text-sm font-sans font-semibold tracking-widest uppercase text-orange mb-6" data-id="element-162">
              Current Ventures
            </h2>
            <h3 className="text-4xl md:text-6xl font-serif text-navy" data-id="element-163">
              Built in the cave.
            </h3>
          </div>
          <p className="text-lg text-navy/70 max-w-md font-light" data-id="element-164">
            A selection of products currently in active development or recently
            spun out into independent companies.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-165">
          {ventures.map((venture, index) => <motion.div key={venture.name} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group relative bg-white p-8 md:p-10 rounded-2xl border border-navy/5 hover:border-orange/30 transition-all duration-300 hover:shadow-xl hover:shadow-orange/5 flex flex-col h-full" data-id="element-166">
              <div className="flex justify-between items-start mb-12" data-id="element-167">
                <div className={`w-14 h-14 rounded-xl ${venture.color} flex items-center justify-center`} data-id="element-168">
                  <venture.icon className={`w-7 h-7 ${venture.iconColor}`} data-id="element-169" />
                </div>
                {/*<div className="w-10 h-10 rounded-full border border-navy/10 flex items-center justify-center group-hover:bg-orange group-hover:border-orange group-hover:text-white transition-all duration-300">
                  <ArrowUpRight className="w-5 h-5" />
                 </div>*/}
              </div>

              <div className="mt-auto" data-id="element-170">
                <div className="text-xs font-semibold tracking-wider uppercase text-navy/50 mb-3" data-id="element-171">
                  {venture.category}
                </div>
                <h4 className="text-3xl font-serif text-navy mb-4 group-hover:text-orange transition-colors" data-id="element-172">
                  {venture.name}
                </h4>
                <p className="text-navy/70 font-light leading-relaxed" data-id="element-173">
                  {venture.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}